/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7aa39eae7839f7e54fc07b5614a5359>>
 * @codegenCommand yarn build tokens
 */

type TokenValue =
	| string
	| number
	| {
		radius: number;
		offset: {
			x: number;
			y: number;
		};
		color: string;
		opacity: number;
		spread?: number;
		inset?: boolean;
	}[];

type TokenValueOriginal =
	| string
	| {
		radius: number;
		offset: {
			x: number;
			y: number;
		};
		color: string;
		opacity: number;
		spread?: number;
		inset?: boolean;
	}[];

type TokenAttributes = {
	group: string;
	state: string;
	introduced: string;
	description: string;
	suggest?: string[];
	deprecated?: string;
	replacement?: string;
};


type Token = {
	value: TokenValue;
	filePath: string;
	isSource: boolean;
	attributes: TokenAttributes;
	original: {
		value: TokenValueOriginal;
		attributes: TokenAttributes;
	};
	name: string;
	path: string[];
	cleanName: string;
};

const tokens: Token[] = [
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
    },
    "value": "#CECFD2",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
      },
      "value": "DarkNeutral1000"
    },
    "name": "color.text.[default]",
    "path": [
      "color",
      "text",
      "[default]"
    ],
    "cleanName": "color.text"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Lime300"
    },
    "name": "color.text.accent.lime.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "lime",
      "[default]"
    ],
    "cleanName": "color.text.accent.lime"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#D3F1A7",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Lime200"
    },
    "name": "color.text.accent.lime.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "lime",
      "bolder"
    ],
    "cleanName": "color.text.accent.lime.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#FD9891",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Red300"
    },
    "name": "color.text.accent.red.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "red",
      "[default]"
    ],
    "cleanName": "color.text.accent.red"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#FFD5D2",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Red200"
    },
    "name": "color.text.accent.red.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "red",
      "bolder"
    ],
    "cleanName": "color.text.accent.red.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Orange300"
    },
    "name": "color.text.accent.orange.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "orange",
      "[default]"
    ],
    "cleanName": "color.text.accent.orange"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#FCE4A6",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Orange200"
    },
    "name": "color.text.accent.orange.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "orange",
      "bolder"
    ],
    "cleanName": "color.text.accent.orange.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#EED12B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Yellow300"
    },
    "name": "color.text.accent.yellow.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "yellow",
      "[default]"
    ],
    "cleanName": "color.text.accent.yellow"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#F5E989",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Yellow200"
    },
    "name": "color.text.accent.yellow.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "yellow",
      "bolder"
    ],
    "cleanName": "color.text.accent.yellow.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#7EE2B8",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Green300"
    },
    "name": "color.text.accent.green.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "green",
      "[default]"
    ],
    "cleanName": "color.text.accent.green"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#BAF3DB",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Green200"
    },
    "name": "color.text.accent.green.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "green",
      "bolder"
    ],
    "cleanName": "color.text.accent.green.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#9DD9EE",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Teal300"
    },
    "name": "color.text.accent.teal.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "teal",
      "[default]"
    ],
    "cleanName": "color.text.accent.teal"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#C6EDFB",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Teal200"
    },
    "name": "color.text.accent.teal.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "teal",
      "bolder"
    ],
    "cleanName": "color.text.accent.teal.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Blue300"
    },
    "name": "color.text.accent.blue.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "blue",
      "[default]"
    ],
    "cleanName": "color.text.accent.blue"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#CFE1FD",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Blue200"
    },
    "name": "color.text.accent.blue.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "blue",
      "bolder"
    ],
    "cleanName": "color.text.accent.blue.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Purple300"
    },
    "name": "color.text.accent.purple.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "purple",
      "[default]"
    ],
    "cleanName": "color.text.accent.purple"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#EED7FC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Purple200"
    },
    "name": "color.text.accent.purple.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "purple",
      "bolder"
    ],
    "cleanName": "color.text.accent.purple.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#F797D2",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Magenta300"
    },
    "name": "color.text.accent.magenta.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "magenta",
      "[default]"
    ],
    "cleanName": "color.text.accent.magenta"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
    },
    "value": "#FDD0EC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
      },
      "value": "Magenta200"
    },
    "name": "color.text.accent.magenta.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "magenta",
      "bolder"
    ],
    "cleanName": "color.text.accent.magenta.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.5",
      "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.5",
        "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
      },
      "value": "DarkNeutral800"
    },
    "name": "color.text.accent.gray.[default]",
    "path": [
      "color",
      "text",
      "accent",
      "gray",
      "[default]"
    ],
    "cleanName": "color.text.accent.gray"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.5",
      "description": "Use for text and icons on gray subtle accent backgrounds."
    },
    "value": "#E2E3E4",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.5",
        "description": "Use for text and icons on gray subtle accent backgrounds."
      },
      "value": "DarkNeutral1100"
    },
    "name": "color.text.accent.gray.bolder",
    "path": [
      "color",
      "text",
      "accent",
      "gray",
      "bolder"
    ],
    "cleanName": "color.text.accent.gray.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for text in a disabled state."
    },
    "value": "#E5E9F640",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for text in a disabled state."
      },
      "value": "DarkNeutral400A"
    },
    "name": "color.text.disabled",
    "path": [
      "color",
      "text",
      "disabled"
    ],
    "cleanName": "color.text.disabled"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for text on bold backgrounds."
    },
    "value": "#1F1F21",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for text on bold backgrounds."
      },
      "value": "DarkNeutral100"
    },
    "name": "color.text.inverse",
    "path": [
      "color",
      "text",
      "inverse"
    ],
    "cleanName": "color.text.inverse"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for text in selected or opened states, such as tabs and dropdown buttons."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for text in selected or opened states, such as tabs and dropdown buttons."
      },
      "value": "Blue400"
    },
    "name": "color.text.selected",
    "path": [
      "color",
      "text",
      "selected"
    ],
    "cleanName": "color.text.selected"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for text that reinforces our brand."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for text that reinforces our brand."
      },
      "value": "Blue400"
    },
    "name": "color.text.brand",
    "path": [
      "color",
      "text",
      "brand"
    ],
    "cleanName": "color.text.brand"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for critical text, such as input field error messaging."
    },
    "value": "#FD9891",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for critical text, such as input field error messaging."
      },
      "value": "Red300"
    },
    "name": "color.text.danger.[default]",
    "path": [
      "color",
      "text",
      "danger",
      "[default]"
    ],
    "cleanName": "color.text.danger"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
    },
    "value": "#FFD5D2",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
      },
      "value": "Red200"
    },
    "name": "color.text.danger.bolder",
    "path": [
      "color",
      "text",
      "danger",
      "bolder"
    ],
    "cleanName": "color.text.danger.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for text to emphasize caution, such as in moved lozenges."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for text to emphasize caution, such as in moved lozenges."
      },
      "value": "Orange300"
    },
    "name": "color.text.warning.[default]",
    "path": [
      "color",
      "text",
      "warning",
      "[default]"
    ],
    "cleanName": "color.text.warning"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for text when on bold warning backgrounds."
    },
    "value": "#1F1F21",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for text when on bold warning backgrounds."
      },
      "value": "DarkNeutral100"
    },
    "name": "color.text.warning.inverse",
    "path": [
      "color",
      "text",
      "warning",
      "inverse"
    ],
    "cleanName": "color.text.warning.inverse"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
    },
    "value": "#FCE4A6",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
      },
      "value": "Orange200"
    },
    "name": "color.text.warning.bolder",
    "path": [
      "color",
      "text",
      "warning",
      "bolder"
    ],
    "cleanName": "color.text.warning.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
      },
      "value": "Lime300"
    },
    "name": "color.text.success.[default]",
    "path": [
      "color",
      "text",
      "success",
      "[default]"
    ],
    "cleanName": "color.text.success"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
    },
    "value": "#D3F1A7",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
      },
      "value": "Lime200"
    },
    "name": "color.text.success.bolder",
    "path": [
      "color",
      "text",
      "success",
      "bolder"
    ],
    "cleanName": "color.text.success.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for text to emphasize change or something new, such as in new lozenges."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for text to emphasize change or something new, such as in new lozenges."
      },
      "value": "Purple300"
    },
    "name": "color.text.discovery.[default]",
    "path": [
      "color",
      "text",
      "discovery",
      "[default]"
    ],
    "cleanName": "color.text.discovery"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
    },
    "value": "#EED7FC",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
      },
      "value": "Purple200"
    },
    "name": "color.text.discovery.bolder",
    "path": [
      "color",
      "text",
      "discovery",
      "bolder"
    ],
    "cleanName": "color.text.discovery.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
      },
      "value": "Blue300"
    },
    "name": "color.text.information.[default]",
    "path": [
      "color",
      "text",
      "information",
      "[default]"
    ],
    "cleanName": "color.text.information"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
    },
    "value": "#CFE1FD",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
      },
      "value": "Blue200"
    },
    "name": "color.text.information.bolder",
    "path": [
      "color",
      "text",
      "information",
      "bolder"
    ],
    "cleanName": "color.text.information.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
    },
    "value": "#96999E",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
      },
      "value": "DarkNeutral700"
    },
    "name": "color.text.subtlest",
    "path": [
      "color",
      "text",
      "subtlest"
    ],
    "cleanName": "color.text.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
      },
      "value": "DarkNeutral800"
    },
    "name": "color.text.subtle",
    "path": [
      "color",
      "text",
      "subtle"
    ],
    "cleanName": "color.text.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for links in a default or hovered state. Add an underline for hovered states."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for links in a default or hovered state. Add an underline for hovered states."
      },
      "value": "Blue400"
    },
    "name": "color.link.[default]",
    "path": [
      "color",
      "link",
      "[default]"
    ],
    "cleanName": "color.link"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for links in a pressed state."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for links in a pressed state."
      },
      "value": "Blue300"
    },
    "name": "color.link.pressed",
    "path": [
      "color",
      "link",
      "pressed"
    ],
    "cleanName": "color.link.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.23.0",
      "description": "Use for visited links."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.23.0",
        "description": "Use for visited links."
      },
      "value": "Purple300"
    },
    "name": "color.link.visited.[default]",
    "path": [
      "color",
      "link",
      "visited",
      "[default]"
    ],
    "cleanName": "color.link.visited"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.43.0",
      "description": "Use for visited links in a pressed state."
    },
    "value": "#EED7FC",
    "filePath": "schema/themes/atlassian-dark/color/text.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.43.0",
        "description": "Use for visited links in a pressed state."
      },
      "value": "Purple200"
    },
    "name": "color.link.visited.pressed",
    "path": [
      "color",
      "link",
      "visited",
      "pressed"
    ],
    "cleanName": "color.link.visited.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icon-only buttons, or icons paired with color.text"
    },
    "value": "#CECFD2",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icon-only buttons, or icons paired with color.text"
      },
      "value": "DarkNeutral1000"
    },
    "name": "color.icon.[default]",
    "path": [
      "color",
      "icon",
      "[default]"
    ],
    "cleanName": "color.icon"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.6.0",
      "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#82B536",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.6.0",
        "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Lime500"
    },
    "name": "color.icon.accent.lime",
    "path": [
      "color",
      "icon",
      "accent",
      "lime"
    ],
    "cleanName": "color.icon.accent.lime"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#E2483D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Red600"
    },
    "name": "color.icon.accent.red",
    "path": [
      "color",
      "icon",
      "accent",
      "red"
    ],
    "cleanName": "color.icon.accent.red"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#F68909",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Orange500"
    },
    "name": "color.icon.accent.orange",
    "path": [
      "color",
      "icon",
      "accent",
      "orange"
    ],
    "cleanName": "color.icon.accent.orange"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#EED12B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Yellow300"
    },
    "name": "color.icon.accent.yellow",
    "path": [
      "color",
      "icon",
      "accent",
      "yellow"
    ],
    "cleanName": "color.icon.accent.yellow"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#2ABB7F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Green500"
    },
    "name": "color.icon.accent.green",
    "path": [
      "color",
      "icon",
      "accent",
      "green"
    ],
    "cleanName": "color.icon.accent.green"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#42B2D7",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Teal500"
    },
    "name": "color.icon.accent.teal",
    "path": [
      "color",
      "icon",
      "accent",
      "teal"
    ],
    "cleanName": "color.icon.accent.teal"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Blue500"
    },
    "name": "color.icon.accent.blue",
    "path": [
      "color",
      "icon",
      "accent",
      "blue"
    ],
    "cleanName": "color.icon.accent.blue"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Purple500"
    },
    "name": "color.icon.accent.purple",
    "path": [
      "color",
      "icon",
      "accent",
      "purple"
    ],
    "cleanName": "color.icon.accent.purple"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
    },
    "value": "#DA62AC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
      },
      "value": "Magenta500"
    },
    "name": "color.icon.accent.magenta",
    "path": [
      "color",
      "icon",
      "accent",
      "magenta"
    ],
    "cleanName": "color.icon.accent.magenta"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.5",
      "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.5",
        "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.icon.accent.gray",
    "path": [
      "color",
      "icon",
      "accent",
      "gray"
    ],
    "cleanName": "color.icon.accent.gray"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons in a disabled state."
    },
    "value": "#E5E9F640",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons in a disabled state."
      },
      "value": "DarkNeutral400A"
    },
    "name": "color.icon.disabled",
    "path": [
      "color",
      "icon",
      "disabled"
    ],
    "cleanName": "color.icon.disabled"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons on bold backgrounds."
    },
    "value": "#1F1F21",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons on bold backgrounds."
      },
      "value": "DarkNeutral100"
    },
    "name": "color.icon.inverse",
    "path": [
      "color",
      "icon",
      "inverse"
    ],
    "cleanName": "color.icon.inverse"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Use for icons in selected or opened states, such as those used in dropdown buttons."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Use for icons in selected or opened states, such as those used in dropdown buttons."
      },
      "value": "Blue400"
    },
    "name": "color.icon.selected",
    "path": [
      "color",
      "icon",
      "selected"
    ],
    "cleanName": "color.icon.selected"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons that reinforce our brand."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons that reinforce our brand."
      },
      "value": "Blue400"
    },
    "name": "color.icon.brand",
    "path": [
      "color",
      "icon",
      "brand"
    ],
    "cleanName": "color.icon.brand"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons communicating critical information, such as those used in error handing."
    },
    "value": "#F15B50",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons communicating critical information, such as those used in error handing."
      },
      "value": "Red500"
    },
    "name": "color.icon.danger",
    "path": [
      "color",
      "icon",
      "danger"
    ],
    "cleanName": "color.icon.danger"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons communicating caution, such as those used in warning section messages."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons communicating caution, such as those used in warning section messages."
      },
      "value": "Orange300"
    },
    "name": "color.icon.warning.[default]",
    "path": [
      "color",
      "icon",
      "warning",
      "[default]"
    ],
    "cleanName": "color.icon.warning"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons when on bold warning backgrounds."
    },
    "value": "#1F1F21",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons when on bold warning backgrounds."
      },
      "value": "DarkNeutral100"
    },
    "name": "color.icon.warning.inverse",
    "path": [
      "color",
      "icon",
      "warning",
      "inverse"
    ],
    "cleanName": "color.icon.warning.inverse"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
    },
    "value": "#82B536",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
      },
      "value": "Lime500"
    },
    "name": "color.icon.success",
    "path": [
      "color",
      "icon",
      "success"
    ],
    "cleanName": "color.icon.success"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons communicating change or something new, such as discovery section messages."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons communicating change or something new, such as discovery section messages."
      },
      "value": "Purple500"
    },
    "name": "color.icon.discovery",
    "path": [
      "color",
      "icon",
      "discovery"
    ],
    "cleanName": "color.icon.discovery"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons communicating information or something in-progress, such as information section messages."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons communicating information or something in-progress, such as information section messages."
      },
      "value": "Blue500"
    },
    "name": "color.icon.information",
    "path": [
      "color",
      "icon",
      "information"
    ],
    "cleanName": "color.icon.information"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.54.0",
      "description": "Use for icons paired with color.text.subtlest"
    },
    "value": "#96999E",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.54.0",
        "description": "Use for icons paired with color.text.subtlest"
      },
      "value": "DarkNeutral700"
    },
    "name": "color.icon.subtlest",
    "path": [
      "color",
      "icon",
      "subtlest"
    ],
    "cleanName": "color.icon.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for icons paired with color.text.subtle"
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for icons paired with color.text.subtle"
      },
      "value": "DarkNeutral800"
    },
    "name": "color.icon.subtle",
    "path": [
      "color",
      "icon",
      "subtle"
    ],
    "cleanName": "color.icon.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
    },
    "value": "#E3E4F21F",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
      },
      "value": "DarkNeutral300A"
    },
    "name": "color.border.[default]",
    "path": [
      "color",
      "border",
      "[default]"
    ],
    "cleanName": "color.border"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.6.0",
      "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#82B536",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.6.0",
        "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Lime500"
    },
    "name": "color.border.accent.lime",
    "path": [
      "color",
      "border",
      "accent",
      "lime"
    ],
    "cleanName": "color.border.accent.lime"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#F15B50",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Red500"
    },
    "name": "color.border.accent.red",
    "path": [
      "color",
      "border",
      "accent",
      "red"
    ],
    "cleanName": "color.border.accent.red"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#F68909",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Orange500"
    },
    "name": "color.border.accent.orange",
    "path": [
      "color",
      "border",
      "accent",
      "orange"
    ],
    "cleanName": "color.border.accent.orange"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#CF9F02",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Yellow500"
    },
    "name": "color.border.accent.yellow",
    "path": [
      "color",
      "border",
      "accent",
      "yellow"
    ],
    "cleanName": "color.border.accent.yellow"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#2ABB7F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Green500"
    },
    "name": "color.border.accent.green",
    "path": [
      "color",
      "border",
      "accent",
      "green"
    ],
    "cleanName": "color.border.accent.green"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#42B2D7",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Teal500"
    },
    "name": "color.border.accent.teal",
    "path": [
      "color",
      "border",
      "accent",
      "teal"
    ],
    "cleanName": "color.border.accent.teal"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Blue500"
    },
    "name": "color.border.accent.blue",
    "path": [
      "color",
      "border",
      "accent",
      "blue"
    ],
    "cleanName": "color.border.accent.blue"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Purple500"
    },
    "name": "color.border.accent.purple",
    "path": [
      "color",
      "border",
      "accent",
      "purple"
    ],
    "cleanName": "color.border.accent.purple"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
    },
    "value": "#DA62AC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
      },
      "value": "Magenta500"
    },
    "name": "color.border.accent.magenta",
    "path": [
      "color",
      "border",
      "accent",
      "magenta"
    ],
    "cleanName": "color.border.accent.magenta"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.5",
      "description": "Use for borders on non-bold gray accent backgrounds."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.5",
        "description": "Use for borders on non-bold gray accent backgrounds."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.border.accent.gray",
    "path": [
      "color",
      "border",
      "accent",
      "gray"
    ],
    "cleanName": "color.border.accent.gray"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders of elements in a disabled state."
    },
    "value": "#CECED912",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders of elements in a disabled state."
      },
      "value": "DarkNeutral200A"
    },
    "name": "color.border.disabled",
    "path": [
      "color",
      "border",
      "disabled"
    ],
    "cleanName": "color.border.disabled"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for focus rings of elements in a focus state."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for focus rings of elements in a focus state."
      },
      "value": "Blue300"
    },
    "name": "color.border.focused",
    "path": [
      "color",
      "border",
      "focused"
    ],
    "cleanName": "color.border.focused"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.border.input",
    "path": [
      "color",
      "border",
      "input"
    ],
    "cleanName": "color.border.input"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders on bold backgrounds."
    },
    "value": "#18191A",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders on bold backgrounds."
      },
      "value": "DarkNeutral0"
    },
    "name": "color.border.inverse",
    "path": [
      "color",
      "border",
      "inverse"
    ],
    "cleanName": "color.border.inverse"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Use for borders or visual indicators of elements in a selected or opened state, such as in tabs or menu items."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Use for borders or visual indicators of elements in a selected or opened state, such as in tabs or menu items."
      },
      "value": "Blue400"
    },
    "name": "color.border.selected",
    "path": [
      "color",
      "border",
      "selected"
    ],
    "cleanName": "color.border.selected"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
      },
      "value": "Blue400"
    },
    "name": "color.border.brand",
    "path": [
      "color",
      "border",
      "brand"
    ],
    "cleanName": "color.border.brand"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
    },
    "value": "#F15B50",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
      },
      "value": "Red500"
    },
    "name": "color.border.danger",
    "path": [
      "color",
      "border",
      "danger"
    ],
    "cleanName": "color.border.danger"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders communicating caution."
    },
    "value": "#F68909",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders communicating caution."
      },
      "value": "Orange500"
    },
    "name": "color.border.warning",
    "path": [
      "color",
      "border",
      "warning"
    ],
    "cleanName": "color.border.warning"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
    },
    "value": "#82B536",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
      },
      "value": "Lime500"
    },
    "name": "color.border.success",
    "path": [
      "color",
      "border",
      "success"
    ],
    "cleanName": "color.border.success"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
      },
      "value": "Purple500"
    },
    "name": "color.border.discovery",
    "path": [
      "color",
      "border",
      "discovery"
    ],
    "cleanName": "color.border.discovery"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for borders communicating information or something in-progress."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for borders communicating information or something in-progress."
      },
      "value": "Blue500"
    },
    "name": "color.border.information",
    "path": [
      "color",
      "border",
      "information"
    ],
    "cleanName": "color.border.information"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.8",
      "description": "A neutral border option that passes min 3:1 contrast ratios."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/border.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.8",
        "description": "A neutral border option that passes min 3:1 contrast ratios."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.border.bold",
    "path": [
      "color",
      "border",
      "bold"
    ],
    "cleanName": "color.border.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.6.0",
      "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#28311B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.6.0",
        "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Lime1000"
    },
    "name": "color.background.accent.lime.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.lime.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.lime.subtlest."
    },
    "value": "#37471F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.lime.subtlest."
      },
      "value": "Lime900"
    },
    "name": "color.background.accent.lime.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.lime.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.lime.subtlest."
    },
    "value": "#3F5224",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.lime.subtlest."
      },
      "value": "Lime850"
    },
    "name": "color.background.accent.lime.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.lime.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.6.0",
      "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#37471F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.6.0",
        "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Lime900"
    },
    "name": "color.background.accent.lime.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.lime.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.lime.subtler."
    },
    "value": "#3F5224",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.lime.subtler."
      },
      "value": "Lime850"
    },
    "name": "color.background.accent.lime.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.lime.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.lime.subtler."
    },
    "value": "#4C6B1F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.lime.subtler."
      },
      "value": "Lime800"
    },
    "name": "color.background.accent.lime.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.lime.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.6.0",
      "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#4C6B1F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.6.0",
        "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Lime800"
    },
    "name": "color.background.accent.lime.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.lime.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.lime.subtle."
    },
    "value": "#3F5224",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.lime.subtle."
      },
      "value": "Lime850"
    },
    "name": "color.background.accent.lime.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.lime.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.lime.subtle."
    },
    "value": "#37471F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.lime.subtle."
      },
      "value": "Lime900"
    },
    "name": "color.background.accent.lime.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.lime.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.6.0",
      "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#94C748",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.6.0",
        "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Lime400"
    },
    "name": "color.background.accent.lime.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.lime.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.lime.bolder."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.lime.bolder."
      },
      "value": "Lime300"
    },
    "name": "color.background.accent.lime.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.lime.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.lime.bolder."
    },
    "value": "#BDE97C",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.lime.bolder."
      },
      "value": "Lime250"
    },
    "name": "color.background.accent.lime.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "lime",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.lime.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#42221F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Red1000"
    },
    "name": "color.background.accent.red.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.red.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.red.subtlest."
    },
    "value": "#5D1F1A",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.red.subtlest."
      },
      "value": "Red900"
    },
    "name": "color.background.accent.red.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.red.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.red.subtlest."
    },
    "value": "#872821",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.red.subtlest."
      },
      "value": "Red850"
    },
    "name": "color.background.accent.red.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.red.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#5D1F1A",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Red900"
    },
    "name": "color.background.accent.red.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.red.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.red.subtler."
    },
    "value": "#872821",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.red.subtler."
      },
      "value": "Red850"
    },
    "name": "color.background.accent.red.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.red.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.red.subtler."
    },
    "value": "#AE2E24",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.red.subtler."
      },
      "value": "Red800"
    },
    "name": "color.background.accent.red.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.red.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#AE2E24",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Red800"
    },
    "name": "color.background.accent.red.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.red.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.red.subtle."
    },
    "value": "#872821",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.red.subtle."
      },
      "value": "Red850"
    },
    "name": "color.background.accent.red.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.red.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.red.subtle."
    },
    "value": "#5D1F1A",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.red.subtle."
      },
      "value": "Red900"
    },
    "name": "color.background.accent.red.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.red.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#F87168",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Red400"
    },
    "name": "color.background.accent.red.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.red.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.red.bolder."
    },
    "value": "#FD9891",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.red.bolder."
      },
      "value": "Red300"
    },
    "name": "color.background.accent.red.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.red.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.red.bolder."
    },
    "value": "#FFB8B2",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.red.bolder."
      },
      "value": "Red250"
    },
    "name": "color.background.accent.red.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "red",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.red.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#3A2C1F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Orange1000"
    },
    "name": "color.background.accent.orange.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.orange.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.orange.subtlest."
    },
    "value": "#693200",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.orange.subtlest."
      },
      "value": "Orange900"
    },
    "name": "color.background.accent.orange.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.orange.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.orange.subtlest."
    },
    "value": "#7A3B00",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.orange.subtlest."
      },
      "value": "Orange850"
    },
    "name": "color.background.accent.orange.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.orange.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#693200",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Orange900"
    },
    "name": "color.background.accent.orange.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.orange.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.orange.subtler."
    },
    "value": "#7A3B00",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.orange.subtler."
      },
      "value": "Orange850"
    },
    "name": "color.background.accent.orange.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.orange.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.orange.subtler."
    },
    "value": "#9E4C00",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.orange.subtler."
      },
      "value": "Orange800"
    },
    "name": "color.background.accent.orange.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.orange.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#9E4C00",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Orange800"
    },
    "name": "color.background.accent.orange.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.orange.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.orange.subtle."
    },
    "value": "#7A3B00",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.orange.subtle."
      },
      "value": "Orange850"
    },
    "name": "color.background.accent.orange.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.orange.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.orange.subtle."
    },
    "value": "#693200",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.orange.subtle."
      },
      "value": "Orange900"
    },
    "name": "color.background.accent.orange.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.orange.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#FCA700",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Orange400"
    },
    "name": "color.background.accent.orange.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.orange.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.orange.bolder."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.orange.bolder."
      },
      "value": "Orange300"
    },
    "name": "color.background.accent.orange.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.orange.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.orange.bolder."
    },
    "value": "#FBD779",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.orange.bolder."
      },
      "value": "Orange250"
    },
    "name": "color.background.accent.orange.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "orange",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.orange.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#332E1B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Yellow1000"
    },
    "name": "color.background.accent.yellow.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.yellow.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.yellow.subtlest."
    },
    "value": "#533F04",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.yellow.subtlest."
      },
      "value": "Yellow900"
    },
    "name": "color.background.accent.yellow.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.yellow.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.yellow.subtlest."
    },
    "value": "#614A05",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.yellow.subtlest."
      },
      "value": "Yellow850"
    },
    "name": "color.background.accent.yellow.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.yellow.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#533F04",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Yellow900"
    },
    "name": "color.background.accent.yellow.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.yellow.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.yellow.subtler."
    },
    "value": "#614A05",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.yellow.subtler."
      },
      "value": "Yellow850"
    },
    "name": "color.background.accent.yellow.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.yellow.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.yellow.subtler."
    },
    "value": "#7F5F01",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.yellow.subtler."
      },
      "value": "Yellow800"
    },
    "name": "color.background.accent.yellow.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.yellow.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#7F5F01",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Yellow800"
    },
    "name": "color.background.accent.yellow.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.yellow.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.yellow.subtle."
    },
    "value": "#614A05",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.yellow.subtle."
      },
      "value": "Yellow850"
    },
    "name": "color.background.accent.yellow.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.yellow.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.yellow.subtle."
    },
    "value": "#533F04",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.yellow.subtle."
      },
      "value": "Yellow900"
    },
    "name": "color.background.accent.yellow.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.yellow.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#DDB30E",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Yellow400"
    },
    "name": "color.background.accent.yellow.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.yellow.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.yellow.bolder."
    },
    "value": "#EED12B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.yellow.bolder."
      },
      "value": "Yellow300"
    },
    "name": "color.background.accent.yellow.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.yellow.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.yellow.bolder."
    },
    "value": "#EFDD4E",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.yellow.bolder."
      },
      "value": "Yellow250"
    },
    "name": "color.background.accent.yellow.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "yellow",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.yellow.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#1C3329",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Green1000"
    },
    "name": "color.background.accent.green.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.green.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.green.subtlest."
    },
    "value": "#164B35",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.green.subtlest."
      },
      "value": "Green900"
    },
    "name": "color.background.accent.green.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.green.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.green.subtlest."
    },
    "value": "#19573D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.green.subtlest."
      },
      "value": "Green850"
    },
    "name": "color.background.accent.green.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.green.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#164B35",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Green900"
    },
    "name": "color.background.accent.green.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.green.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.green.subtler."
    },
    "value": "#19573D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.green.subtler."
      },
      "value": "Green850"
    },
    "name": "color.background.accent.green.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.green.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.green.subtler."
    },
    "value": "#216E4E",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.green.subtler."
      },
      "value": "Green800"
    },
    "name": "color.background.accent.green.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.green.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#216E4E",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Green800"
    },
    "name": "color.background.accent.green.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.green.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.green.subtle."
    },
    "value": "#19573D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.green.subtle."
      },
      "value": "Green850"
    },
    "name": "color.background.accent.green.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.green.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.green.subtle."
    },
    "value": "#164B35",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.green.subtle."
      },
      "value": "Green900"
    },
    "name": "color.background.accent.green.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.green.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#4BCE97",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Green400"
    },
    "name": "color.background.accent.green.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.green.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.green.bolder."
    },
    "value": "#7EE2B8",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.green.bolder."
      },
      "value": "Green300"
    },
    "name": "color.background.accent.green.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.green.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.green.bolder."
    },
    "value": "#97EDC9",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.green.bolder."
      },
      "value": "Green250"
    },
    "name": "color.background.accent.green.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "green",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.green.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#1E3137",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Teal1000"
    },
    "name": "color.background.accent.teal.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.teal.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.teal.subtlest."
    },
    "value": "#164555",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.teal.subtlest."
      },
      "value": "Teal900"
    },
    "name": "color.background.accent.teal.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.teal.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.teal.subtlest."
    },
    "value": "#1A5265",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.teal.subtlest."
      },
      "value": "Teal850"
    },
    "name": "color.background.accent.teal.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.teal.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#164555",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Teal900"
    },
    "name": "color.background.accent.teal.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.teal.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.teal.subtler."
    },
    "value": "#1A5265",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.teal.subtler."
      },
      "value": "Teal850"
    },
    "name": "color.background.accent.teal.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.teal.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.teal.subtler."
    },
    "value": "#206A83",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.teal.subtler."
      },
      "value": "Teal800"
    },
    "name": "color.background.accent.teal.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.teal.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#206A83",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Teal800"
    },
    "name": "color.background.accent.teal.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.teal.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.teal.subtle."
    },
    "value": "#1A5265",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.teal.subtle."
      },
      "value": "Teal850"
    },
    "name": "color.background.accent.teal.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.teal.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.teal.subtle."
    },
    "value": "#164555",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.teal.subtle."
      },
      "value": "Teal900"
    },
    "name": "color.background.accent.teal.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.teal.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#6CC3E0",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Teal400"
    },
    "name": "color.background.accent.teal.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.teal.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.teal.bolder."
    },
    "value": "#9DD9EE",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.teal.bolder."
      },
      "value": "Teal300"
    },
    "name": "color.background.accent.teal.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.teal.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.teal.bolder."
    },
    "value": "#B1E4F7",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.teal.bolder."
      },
      "value": "Teal250"
    },
    "name": "color.background.accent.teal.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "teal",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.teal.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#1C2B42",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Blue1000"
    },
    "name": "color.background.accent.blue.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.blue.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.blue.subtlest."
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.blue.subtlest."
      },
      "value": "Blue900"
    },
    "name": "color.background.accent.blue.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.blue.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.blue.subtlest."
    },
    "value": "#144794",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.blue.subtlest."
      },
      "value": "Blue850"
    },
    "name": "color.background.accent.blue.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.blue.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Blue900"
    },
    "name": "color.background.accent.blue.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.blue.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.blue.subtler."
    },
    "value": "#144794",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.blue.subtler."
      },
      "value": "Blue850"
    },
    "name": "color.background.accent.blue.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.blue.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.blue.subtler."
    },
    "value": "#1558BC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.blue.subtler."
      },
      "value": "Blue800"
    },
    "name": "color.background.accent.blue.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.blue.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#1558BC",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Blue800"
    },
    "name": "color.background.accent.blue.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.blue.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.blue.subtle."
    },
    "value": "#144794",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.blue.subtle."
      },
      "value": "Blue850"
    },
    "name": "color.background.accent.blue.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.blue.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.blue.subtle."
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.blue.subtle."
      },
      "value": "Blue900"
    },
    "name": "color.background.accent.blue.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.blue.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Blue400"
    },
    "name": "color.background.accent.blue.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.blue.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.blue.bolder."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.blue.bolder."
      },
      "value": "Blue300"
    },
    "name": "color.background.accent.blue.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.blue.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.blue.bolder."
    },
    "value": "#ADCBFB",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.blue.bolder."
      },
      "value": "Blue250"
    },
    "name": "color.background.accent.blue.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "blue",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.blue.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#35243F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Purple1000"
    },
    "name": "color.background.accent.purple.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.purple.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.purple.subtlest."
    },
    "value": "#48245D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.purple.subtlest."
      },
      "value": "Purple900"
    },
    "name": "color.background.accent.purple.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.purple.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.purple.subtlest."
    },
    "value": "#673286",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.purple.subtlest."
      },
      "value": "Purple850"
    },
    "name": "color.background.accent.purple.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.purple.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#48245D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Purple900"
    },
    "name": "color.background.accent.purple.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.purple.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.purple.subtler."
    },
    "value": "#673286",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.purple.subtler."
      },
      "value": "Purple850"
    },
    "name": "color.background.accent.purple.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.purple.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.purple.subtler."
    },
    "value": "#803FA5",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.purple.subtler."
      },
      "value": "Purple800"
    },
    "name": "color.background.accent.purple.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.purple.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#803FA5",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Purple800"
    },
    "name": "color.background.accent.purple.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.purple.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.purple.subtle."
    },
    "value": "#673286",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.purple.subtle."
      },
      "value": "Purple850"
    },
    "name": "color.background.accent.purple.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.purple.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.purple.subtle."
    },
    "value": "#48245D",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.purple.subtle."
      },
      "value": "Purple900"
    },
    "name": "color.background.accent.purple.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.purple.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#C97CF4",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Purple400"
    },
    "name": "color.background.accent.purple.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.purple.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.purple.bolder."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.purple.bolder."
      },
      "value": "Purple300"
    },
    "name": "color.background.accent.purple.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.purple.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.purple.bolder."
    },
    "value": "#E3BDFA",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.purple.bolder."
      },
      "value": "Purple250"
    },
    "name": "color.background.accent.purple.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "purple",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.purple.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#3D2232",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "Magenta1000"
    },
    "name": "color.background.accent.magenta.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.magenta.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.magenta.subtlest."
    },
    "value": "#50253F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.magenta.subtlest."
      },
      "value": "Magenta900"
    },
    "name": "color.background.accent.magenta.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.magenta.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.magenta.subtlest."
    },
    "value": "#77325B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.magenta.subtlest."
      },
      "value": "Magenta850"
    },
    "name": "color.background.accent.magenta.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.magenta.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#50253F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Magenta900"
    },
    "name": "color.background.accent.magenta.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.magenta.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.magenta.subtler."
    },
    "value": "#77325B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.magenta.subtler."
      },
      "value": "Magenta850"
    },
    "name": "color.background.accent.magenta.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.magenta.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.magenta.subtler."
    },
    "value": "#943D73",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.magenta.subtler."
      },
      "value": "Magenta800"
    },
    "name": "color.background.accent.magenta.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.magenta.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#943D73",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "Magenta800"
    },
    "name": "color.background.accent.magenta.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.magenta.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.magenta.subtle."
    },
    "value": "#77325B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.magenta.subtle."
      },
      "value": "Magenta850"
    },
    "name": "color.background.accent.magenta.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.magenta.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.magenta.subtle."
    },
    "value": "#50253F",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.magenta.subtle."
      },
      "value": "Magenta900"
    },
    "name": "color.background.accent.magenta.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.magenta.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#E774BB",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "Magenta400"
    },
    "name": "color.background.accent.magenta.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.magenta.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.magenta.bolder."
    },
    "value": "#F797D2",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.magenta.bolder."
      },
      "value": "Magenta300"
    },
    "name": "color.background.accent.magenta.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.magenta.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.magenta.bolder."
    },
    "value": "#FCB6E1",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.magenta.bolder."
      },
      "value": "Magenta250"
    },
    "name": "color.background.accent.magenta.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "magenta",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.magenta.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
    },
    "value": "#303134",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
      },
      "value": "DarkNeutral300"
    },
    "name": "color.background.accent.gray.subtlest.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.accent.gray.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.gray.subtlest."
    },
    "value": "#3D3F43",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.gray.subtlest."
      },
      "value": "DarkNeutral350"
    },
    "name": "color.background.accent.gray.subtlest.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.accent.gray.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.gray.subtlest."
    },
    "value": "#4B4D51",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.gray.subtlest."
      },
      "value": "DarkNeutral400"
    },
    "name": "color.background.accent.gray.subtlest.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.accent.gray.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#4B4D51",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "DarkNeutral400"
    },
    "name": "color.background.accent.gray.subtler.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.accent.gray.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.gray.subtler."
    },
    "value": "#63666B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.gray.subtler."
      },
      "value": "DarkNeutral500"
    },
    "name": "color.background.accent.gray.subtler.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.accent.gray.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.gray.subtler."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.gray.subtler."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.background.accent.gray.subtler.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.accent.gray.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
    },
    "value": "#63666B",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
      },
      "value": "DarkNeutral500"
    },
    "name": "color.background.accent.gray.subtle.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.accent.gray.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.gray.subtle."
    },
    "value": "#4B4D51",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.gray.subtle."
      },
      "value": "DarkNeutral400"
    },
    "name": "color.background.accent.gray.subtle.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.accent.gray.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.gray.subtle."
    },
    "value": "#3D3F43",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.gray.subtle."
      },
      "value": "DarkNeutral350"
    },
    "name": "color.background.accent.gray.subtle.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.accent.gray.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.7.0",
      "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
    },
    "value": "#96999E",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.7.0",
        "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
      },
      "value": "DarkNeutral700"
    },
    "name": "color.background.accent.gray.bolder.[default]",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.background.accent.gray.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Hovered state of color.background.accent.gray.bolder."
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Hovered state of color.background.accent.gray.bolder."
      },
      "value": "DarkNeutral800"
    },
    "name": "color.background.accent.gray.bolder.hovered",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.background.accent.gray.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.19.0",
      "description": "Pressed state of color.background.accent.gray.subtlest."
    },
    "value": "#BFC1C4",
    "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.19.0",
        "description": "Pressed state of color.background.accent.gray.subtlest."
      },
      "value": "DarkNeutral900"
    },
    "name": "color.background.accent.gray.bolder.pressed",
    "path": [
      "color",
      "background",
      "accent",
      "gray",
      "bolder",
      "pressed"
    ],
    "cleanName": "color.background.accent.gray.bolder.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for backgrounds of elements in a disabled state."
    },
    "value": "#E3E4F21F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for backgrounds of elements in a disabled state."
      },
      "value": "DarkNeutral300A"
    },
    "name": "color.background.disabled",
    "path": [
      "color",
      "background",
      "disabled"
    ],
    "cleanName": "color.background.disabled"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
    },
    "value": "#242528",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
      },
      "value": "DarkNeutral200"
    },
    "name": "color.background.input.[default]",
    "path": [
      "color",
      "background",
      "input",
      "[default]"
    ],
    "cleanName": "color.background.input"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state for color.background.input"
    },
    "value": "#2B2C2F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state for color.background.input"
      },
      "value": "DarkNeutral250"
    },
    "name": "color.background.input.hovered",
    "path": [
      "color",
      "background",
      "input",
      "hovered"
    ],
    "cleanName": "color.background.input.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.input"
    },
    "value": "#242528",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.input"
      },
      "value": "DarkNeutral200"
    },
    "name": "color.background.input.pressed",
    "path": [
      "color",
      "background",
      "input",
      "pressed"
    ],
    "cleanName": "color.background.input.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.8.3",
      "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
    },
    "value": "#FFFFFF29",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.8.3",
        "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
      },
      "value": "#FFFFFF29"
    },
    "name": "color.background.inverse.subtle.[default]",
    "path": [
      "color",
      "background",
      "inverse",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.inverse.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.8.3",
      "description": "Use for the hovered state of color.background.inverse.subtle"
    },
    "value": "#FFFFFF3D",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.8.3",
        "description": "Use for the hovered state of color.background.inverse.subtle"
      },
      "value": "#FFFFFF3D"
    },
    "name": "color.background.inverse.subtle.hovered",
    "path": [
      "color",
      "background",
      "inverse",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.inverse.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.8.3",
      "description": "Use for the pressed state of color.background.inverse.subtle"
    },
    "value": "#FFFFFF52",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.8.3",
        "description": "Use for the pressed state of color.background.inverse.subtle"
      },
      "value": "#FFFFFF52"
    },
    "name": "color.background.inverse.subtle.pressed",
    "path": [
      "color",
      "background",
      "inverse",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.inverse.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "The default background for neutral elements, such as default buttons."
    },
    "value": "#CECED912",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "The default background for neutral elements, such as default buttons."
      },
      "value": "DarkNeutral200A"
    },
    "name": "color.background.neutral.[default].[default]",
    "path": [
      "color",
      "background",
      "neutral",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.neutral"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state for color.background.neutral"
    },
    "value": "#E3E4F21F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state for color.background.neutral"
      },
      "value": "DarkNeutral300A"
    },
    "name": "color.background.neutral.[default].hovered",
    "path": [
      "color",
      "background",
      "neutral",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.neutral.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.neutral"
    },
    "value": "#E5E9F640",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.neutral"
      },
      "value": "DarkNeutral400A"
    },
    "name": "color.background.neutral.[default].pressed",
    "path": [
      "color",
      "background",
      "neutral",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.neutral.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
    },
    "value": "#00000000",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
      },
      "value": "transparent"
    },
    "name": "color.background.neutral.subtle.[default]",
    "path": [
      "color",
      "background",
      "neutral",
      "subtle",
      "[default]"
    ],
    "cleanName": "color.background.neutral.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state for color.background.neutral.subtle"
    },
    "value": "#CECED912",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state for color.background.neutral.subtle"
      },
      "value": "DarkNeutral200A"
    },
    "name": "color.background.neutral.subtle.hovered",
    "path": [
      "color",
      "background",
      "neutral",
      "subtle",
      "hovered"
    ],
    "cleanName": "color.background.neutral.subtle.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.neutral.subtle"
    },
    "value": "#E3E4F21F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.neutral.subtle"
      },
      "value": "DarkNeutral300A"
    },
    "name": "color.background.neutral.subtle.pressed",
    "path": [
      "color",
      "background",
      "neutral",
      "subtle",
      "pressed"
    ],
    "cleanName": "color.background.neutral.subtle.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A vibrant background option for neutral UI elements, such as announcement banners."
    },
    "value": "#CECFD2",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A vibrant background option for neutral UI elements, such as announcement banners."
      },
      "value": "DarkNeutral1000"
    },
    "name": "color.background.neutral.bold.[default]",
    "path": [
      "color",
      "background",
      "neutral",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.neutral.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.neutral.bold"
    },
    "value": "#BFC1C4",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.neutral.bold"
      },
      "value": "DarkNeutral900"
    },
    "name": "color.background.neutral.bold.hovered",
    "path": [
      "color",
      "background",
      "neutral",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.neutral.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.neutral.bold"
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.neutral.bold"
      },
      "value": "DarkNeutral800"
    },
    "name": "color.background.neutral.bold.pressed",
    "path": [
      "color",
      "background",
      "neutral",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.neutral.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Use for the background of elements in a selected state, such as in opened dropdown buttons."
    },
    "value": "#1C2B42",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Use for the background of elements in a selected state, such as in opened dropdown buttons."
      },
      "value": "Blue1000"
    },
    "name": "color.background.selected.[default].[default]",
    "path": [
      "color",
      "background",
      "selected",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.selected"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Hovered state for color.background.selected"
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Hovered state for color.background.selected"
      },
      "value": "Blue900"
    },
    "name": "color.background.selected.[default].hovered",
    "path": [
      "color",
      "background",
      "selected",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.selected.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Pressed state for color.background.selected"
    },
    "value": "#1558BC",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Pressed state for color.background.selected"
      },
      "value": "Blue800"
    },
    "name": "color.background.selected.[default].pressed",
    "path": [
      "color",
      "background",
      "selected",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.selected.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Use for the backgrounds of elements in a selected state, such as checkboxes and radio buttons."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Use for the backgrounds of elements in a selected state, such as checkboxes and radio buttons."
      },
      "value": "Blue400"
    },
    "name": "color.background.selected.bold.[default]",
    "path": [
      "color",
      "background",
      "selected",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.selected.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Hovered state of color.background.selected.bold"
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Hovered state of color.background.selected.bold"
      },
      "value": "Blue300"
    },
    "name": "color.background.selected.bold.hovered",
    "path": [
      "color",
      "background",
      "selected",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.selected.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.2",
      "description": "Pressed state of color.background.selected.bold"
    },
    "value": "#CFE1FD",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.2",
        "description": "Pressed state of color.background.selected.bold"
      },
      "value": "Blue200"
    },
    "name": "color.background.selected.bold.pressed",
    "path": [
      "color",
      "background",
      "selected",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.selected.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.13.0",
      "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
    },
    "value": "#1C2B42",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.13.0",
        "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
      },
      "value": "Blue1000"
    },
    "name": "color.background.brand.subtlest.[default]",
    "path": [
      "color",
      "background",
      "brand",
      "subtlest",
      "[default]"
    ],
    "cleanName": "color.background.brand.subtlest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.13.0",
      "description": "Hovered state of color.background.brand.subtlest."
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.13.0",
        "description": "Hovered state of color.background.brand.subtlest."
      },
      "value": "Blue900"
    },
    "name": "color.background.brand.subtlest.hovered",
    "path": [
      "color",
      "background",
      "brand",
      "subtlest",
      "hovered"
    ],
    "cleanName": "color.background.brand.subtlest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.13.0",
      "description": "Pressed state of color.background.brand.subtlest"
    },
    "value": "#144794",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.13.0",
        "description": "Pressed state of color.background.brand.subtlest"
      },
      "value": "Blue850"
    },
    "name": "color.background.brand.subtlest.pressed",
    "path": [
      "color",
      "background",
      "brand",
      "subtlest",
      "pressed"
    ],
    "cleanName": "color.background.brand.subtlest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
      },
      "value": "Blue400"
    },
    "name": "color.background.brand.bold.[default]",
    "path": [
      "color",
      "background",
      "brand",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.brand.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.brand.bold."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.brand.bold."
      },
      "value": "Blue300"
    },
    "name": "color.background.brand.bold.hovered",
    "path": [
      "color",
      "background",
      "brand",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.brand.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.brand.bold."
    },
    "value": "#ADCBFB",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.brand.bold."
      },
      "value": "Blue250"
    },
    "name": "color.background.brand.bold.pressed",
    "path": [
      "color",
      "background",
      "brand",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.brand.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.13.0",
      "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
    },
    "value": "#E9F2FE",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.13.0",
        "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
      },
      "value": "Blue100"
    },
    "name": "color.background.brand.boldest.[default]",
    "path": [
      "color",
      "background",
      "brand",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.background.brand.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.13.0",
      "description": "Hovered state of color.background.brand.boldest."
    },
    "value": "#CFE1FD",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.13.0",
        "description": "Hovered state of color.background.brand.boldest."
      },
      "value": "Blue200"
    },
    "name": "color.background.brand.boldest.hovered",
    "path": [
      "color",
      "background",
      "brand",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.background.brand.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.13.0",
      "description": "Pressed state of color.background.brand.boldest."
    },
    "value": "#ADCBFB",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.13.0",
        "description": "Pressed state of color.background.brand.boldest."
      },
      "value": "Blue250"
    },
    "name": "color.background.brand.boldest.pressed",
    "path": [
      "color",
      "background",
      "brand",
      "boldest",
      "pressed"
    ],
    "cleanName": "color.background.brand.boldest.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for backgrounds communicating critical information, such in error section messages."
    },
    "value": "#42221F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for backgrounds communicating critical information, such in error section messages."
      },
      "value": "Red1000"
    },
    "name": "color.background.danger.[default].[default]",
    "path": [
      "color",
      "background",
      "danger",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.danger"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state for color.background.danger"
    },
    "value": "#5D1F1A",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state for color.background.danger"
      },
      "value": "Red900"
    },
    "name": "color.background.danger.[default].hovered",
    "path": [
      "color",
      "background",
      "danger",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.danger.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.danger"
    },
    "value": "#872821",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.danger"
      },
      "value": "Red850"
    },
    "name": "color.background.danger.[default].pressed",
    "path": [
      "color",
      "background",
      "danger",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.danger.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
    },
    "value": "#5D1F1A",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
      },
      "value": "Red900"
    },
    "name": "color.background.danger.subtler.[default]",
    "path": [
      "color",
      "background",
      "danger",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.danger.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Hovered state of color.background.danger.subtler"
    },
    "value": "#872821",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Hovered state of color.background.danger.subtler"
      },
      "value": "Red850"
    },
    "name": "color.background.danger.subtler.hovered",
    "path": [
      "color",
      "background",
      "danger",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.danger.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Pressed state of color.background.danger.subtler"
    },
    "value": "#AE2E24",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Pressed state of color.background.danger.subtler"
      },
      "value": "Red800"
    },
    "name": "color.background.danger.subtler.pressed",
    "path": [
      "color",
      "background",
      "danger",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.danger.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
    },
    "value": "#F87168",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
      },
      "value": "Red400"
    },
    "name": "color.background.danger.bold.[default]",
    "path": [
      "color",
      "background",
      "danger",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.danger.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.danger.bold"
    },
    "value": "#FD9891",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.danger.bold"
      },
      "value": "Red300"
    },
    "name": "color.background.danger.bold.hovered",
    "path": [
      "color",
      "background",
      "danger",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.danger.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.danger.bold"
    },
    "value": "#FFB8B2",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.danger.bold"
      },
      "value": "Red250"
    },
    "name": "color.background.danger.bold.pressed",
    "path": [
      "color",
      "background",
      "danger",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.danger.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for backgrounds communicating caution, such as in warning section messages."
    },
    "value": "#3A2C1F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for backgrounds communicating caution, such as in warning section messages."
      },
      "value": "Orange1000"
    },
    "name": "color.background.warning.[default].[default]",
    "path": [
      "color",
      "background",
      "warning",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.warning"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state for color.background.warning"
    },
    "value": "#693200",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state for color.background.warning"
      },
      "value": "Orange900"
    },
    "name": "color.background.warning.[default].hovered",
    "path": [
      "color",
      "background",
      "warning",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.warning.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.warning"
    },
    "value": "#7A3B00",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.warning"
      },
      "value": "Orange850"
    },
    "name": "color.background.warning.[default].pressed",
    "path": [
      "color",
      "background",
      "warning",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.warning.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
    },
    "value": "#693200",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
      },
      "value": "Orange900"
    },
    "name": "color.background.warning.subtler.[default]",
    "path": [
      "color",
      "background",
      "warning",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.warning.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Hovered state of color.background.warning.subtler"
    },
    "value": "#7A3B00",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Hovered state of color.background.warning.subtler"
      },
      "value": "Orange850"
    },
    "name": "color.background.warning.subtler.hovered",
    "path": [
      "color",
      "background",
      "warning",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.warning.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Pressed state of color.background.warning.subtler"
    },
    "value": "#9E4C00",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Pressed state of color.background.warning.subtler"
      },
      "value": "Orange800"
    },
    "name": "color.background.warning.subtler.pressed",
    "path": [
      "color",
      "background",
      "warning",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.warning.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
      },
      "value": "Orange300"
    },
    "name": "color.background.warning.bold.[default]",
    "path": [
      "color",
      "background",
      "warning",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.warning.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.warning.bold"
    },
    "value": "#FCA700",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.warning.bold"
      },
      "value": "Orange400"
    },
    "name": "color.background.warning.bold.hovered",
    "path": [
      "color",
      "background",
      "warning",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.warning.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.warning.bold"
    },
    "value": "#F68909",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.warning.bold"
      },
      "value": "Orange500"
    },
    "name": "color.background.warning.bold.pressed",
    "path": [
      "color",
      "background",
      "warning",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.warning.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
    },
    "value": "#28311B",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
      },
      "value": "Lime1000"
    },
    "name": "color.background.success.[default].[default]",
    "path": [
      "color",
      "background",
      "success",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.success"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state for color.background.success"
    },
    "value": "#37471F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state for color.background.success"
      },
      "value": "Lime900"
    },
    "name": "color.background.success.[default].hovered",
    "path": [
      "color",
      "background",
      "success",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.success.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.success"
    },
    "value": "#3F5224",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.success"
      },
      "value": "Lime850"
    },
    "name": "color.background.success.[default].pressed",
    "path": [
      "color",
      "background",
      "success",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.success.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
    },
    "value": "#37471F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
      },
      "value": "Lime900"
    },
    "name": "color.background.success.subtler.[default]",
    "path": [
      "color",
      "background",
      "success",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.success.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Hovered state of color.background.success.subtler"
    },
    "value": "#3F5224",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Hovered state of color.background.success.subtler"
      },
      "value": "Lime850"
    },
    "name": "color.background.success.subtler.hovered",
    "path": [
      "color",
      "background",
      "success",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.success.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Pressed state of color.background.success.subtler"
    },
    "value": "#4C6B1F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Pressed state of color.background.success.subtler"
      },
      "value": "Lime800"
    },
    "name": "color.background.success.subtler.pressed",
    "path": [
      "color",
      "background",
      "success",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.success.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
    },
    "value": "#94C748",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
      },
      "value": "Lime400"
    },
    "name": "color.background.success.bold.[default]",
    "path": [
      "color",
      "background",
      "success",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.success.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.success.bold"
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.success.bold"
      },
      "value": "Lime300"
    },
    "name": "color.background.success.bold.hovered",
    "path": [
      "color",
      "background",
      "success",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.success.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.success.bold"
    },
    "value": "#BDE97C",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.success.bold"
      },
      "value": "Lime250"
    },
    "name": "color.background.success.bold.pressed",
    "path": [
      "color",
      "background",
      "success",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.success.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
    },
    "value": "#35243F",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
      },
      "value": "Purple1000"
    },
    "name": "color.background.discovery.[default].[default]",
    "path": [
      "color",
      "background",
      "discovery",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.discovery"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hover state for color.background.discovery"
    },
    "value": "#48245D",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hover state for color.background.discovery"
      },
      "value": "Purple900"
    },
    "name": "color.background.discovery.[default].hovered",
    "path": [
      "color",
      "background",
      "discovery",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.discovery.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state for color.background.discovery"
    },
    "value": "#673286",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state for color.background.discovery"
      },
      "value": "Purple850"
    },
    "name": "color.background.discovery.[default].pressed",
    "path": [
      "color",
      "background",
      "discovery",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.discovery.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
    },
    "value": "#48245D",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
      },
      "value": "Purple900"
    },
    "name": "color.background.discovery.subtler.[default]",
    "path": [
      "color",
      "background",
      "discovery",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.discovery.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Hovered state of color.background.discovery.subtler"
    },
    "value": "#673286",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Hovered state of color.background.discovery.subtler"
      },
      "value": "Purple850"
    },
    "name": "color.background.discovery.subtler.hovered",
    "path": [
      "color",
      "background",
      "discovery",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.discovery.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Pressed state of color.background.discovery.subtler"
    },
    "value": "#803FA5",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Pressed state of color.background.discovery.subtler"
      },
      "value": "Purple800"
    },
    "name": "color.background.discovery.subtler.pressed",
    "path": [
      "color",
      "background",
      "discovery",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.discovery.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
    },
    "value": "#C97CF4",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
      },
      "value": "Purple400"
    },
    "name": "color.background.discovery.bold.[default]",
    "path": [
      "color",
      "background",
      "discovery",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.discovery.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.discovery.bold"
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.discovery.bold"
      },
      "value": "Purple300"
    },
    "name": "color.background.discovery.bold.hovered",
    "path": [
      "color",
      "background",
      "discovery",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.discovery.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.discovery.bold"
    },
    "value": "#E3BDFA",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.discovery.bold"
      },
      "value": "Purple250"
    },
    "name": "color.background.discovery.bold.pressed",
    "path": [
      "color",
      "background",
      "discovery",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.discovery.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
    },
    "value": "#1C2B42",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
      },
      "value": "Blue1000"
    },
    "name": "color.background.information.[default].[default]",
    "path": [
      "color",
      "background",
      "information",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.background.information"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.information"
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.information"
      },
      "value": "Blue900"
    },
    "name": "color.background.information.[default].hovered",
    "path": [
      "color",
      "background",
      "information",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.background.information.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.information"
    },
    "value": "#144794",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.information"
      },
      "value": "Blue850"
    },
    "name": "color.background.information.[default].pressed",
    "path": [
      "color",
      "background",
      "information",
      "[default]",
      "pressed"
    ],
    "cleanName": "color.background.information.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
    },
    "value": "#123263",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
      },
      "value": "Blue900"
    },
    "name": "color.background.information.subtler.[default]",
    "path": [
      "color",
      "background",
      "information",
      "subtler",
      "[default]"
    ],
    "cleanName": "color.background.information.subtler"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Hovered state of color.background.information.subtler"
    },
    "value": "#144794",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Hovered state of color.background.information.subtler"
      },
      "value": "Blue850"
    },
    "name": "color.background.information.subtler.hovered",
    "path": [
      "color",
      "background",
      "information",
      "subtler",
      "hovered"
    ],
    "cleanName": "color.background.information.subtler.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "8.1.0",
      "description": "Pressed state of color.background.information.subtler"
    },
    "value": "#1558BC",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "8.1.0",
        "description": "Pressed state of color.background.information.subtler"
      },
      "value": "Blue800"
    },
    "name": "color.background.information.subtler.pressed",
    "path": [
      "color",
      "background",
      "information",
      "subtler",
      "pressed"
    ],
    "cleanName": "color.background.information.subtler.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A vibrant background option for communicating information or something in-progress."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A vibrant background option for communicating information or something in-progress."
      },
      "value": "Blue400"
    },
    "name": "color.background.information.bold.[default]",
    "path": [
      "color",
      "background",
      "information",
      "bold",
      "[default]"
    ],
    "cleanName": "color.background.information.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Hovered state of color.background.information.bold"
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Hovered state of color.background.information.bold"
      },
      "value": "Blue300"
    },
    "name": "color.background.information.bold.hovered",
    "path": [
      "color",
      "background",
      "information",
      "bold",
      "hovered"
    ],
    "cleanName": "color.background.information.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Pressed state of color.background.information.bold"
    },
    "value": "#ADCBFB",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Pressed state of color.background.information.bold"
      },
      "value": "Blue250"
    },
    "name": "color.background.information.bold.pressed",
    "path": [
      "color",
      "background",
      "information",
      "bold",
      "pressed"
    ],
    "cleanName": "color.background.information.bold.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.0.15",
      "description": "Use for the screen overlay that appears with modal dialogs"
    },
    "value": "#10121499",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.0.15",
        "description": "Use for the screen overlay that appears with modal dialogs"
      },
      "value": "#10121499"
    },
    "name": "color.blanket.[default]",
    "path": [
      "color",
      "blanket",
      "[default]"
    ],
    "cleanName": "color.blanket"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use as an overlay to communicate selected states when a simple background color change isn't possible, such as in Editor block elements"
    },
    "value": "#1D7AFC14",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use as an overlay to communicate selected states when a simple background color change isn't possible, such as in Editor block elements"
      },
      "value": "#1D7AFC14"
    },
    "name": "color.blanket.selected",
    "path": [
      "color",
      "blanket",
      "selected"
    ],
    "cleanName": "color.blanket.selected"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
    },
    "value": "#E3493514",
    "filePath": "schema/themes/atlassian-dark/color/background.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
      },
      "value": "#E3493514"
    },
    "name": "color.blanket.danger",
    "path": [
      "color",
      "blanket",
      "danger"
    ],
    "cleanName": "color.blanket.danger"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
    },
    "value": "#ffffff33",
    "filePath": "schema/themes/atlassian-dark/color/interaction.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
      },
      "value": "#ffffff33"
    },
    "name": "color.interaction.hovered",
    "path": [
      "color",
      "interaction",
      "hovered"
    ],
    "cleanName": "color.interaction.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
    },
    "value": "#ffffff5c",
    "filePath": "schema/themes/atlassian-dark/color/interaction.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
      },
      "value": "#ffffff5c"
    },
    "name": "color.interaction.pressed",
    "path": [
      "color",
      "interaction",
      "pressed"
    ],
    "cleanName": "color.interaction.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.8.0",
      "description": "Use for skeleton loading states"
    },
    "value": "#CECED912",
    "filePath": "schema/themes/atlassian-dark/color/skeleton.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.8.0",
        "description": "Use for skeleton loading states"
      },
      "value": "DarkNeutral200A"
    },
    "name": "color.skeleton.[default]",
    "path": [
      "color",
      "skeleton",
      "[default]"
    ],
    "cleanName": "color.skeleton"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.8.0",
      "description": "Use for the pulse or shimmer effect in skeleton loading states"
    },
    "value": "#BDBDBD0A",
    "filePath": "schema/themes/atlassian-dark/color/skeleton.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.8.0",
        "description": "Use for the pulse or shimmer effect in skeleton loading states"
      },
      "value": "DarkNeutral100A"
    },
    "name": "color.skeleton.subtle",
    "path": [
      "color",
      "skeleton",
      "subtle"
    ],
    "cleanName": "color.skeleton.subtle"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Blue500"
    },
    "name": "color.chart.categorical.1.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "1",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.1"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.1."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.1."
      },
      "value": "Blue400"
    },
    "name": "color.chart.categorical.1.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "1",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.1.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#94C748",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Lime400"
    },
    "name": "color.chart.categorical.2.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "2",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.2"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.2."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.2."
      },
      "value": "Lime300"
    },
    "name": "color.chart.categorical.2.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "2",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.2.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#C97CF4",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Purple400"
    },
    "name": "color.chart.categorical.3.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "3",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.3"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.3."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.3."
      },
      "value": "Purple300"
    },
    "name": "color.chart.categorical.3.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "3",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.3.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#FCA700",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Orange400"
    },
    "name": "color.chart.categorical.4.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "4",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.4"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.4."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.4."
      },
      "value": "Orange300"
    },
    "name": "color.chart.categorical.4.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "4",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.4.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#1558BC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Blue800"
    },
    "name": "color.chart.categorical.5.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "5",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.5"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.5."
    },
    "value": "#1868DB",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.5."
      },
      "value": "Blue700"
    },
    "name": "color.chart.categorical.5.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "5",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.5.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#964AC0",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Purple700"
    },
    "name": "color.chart.categorical.6.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "6",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.6"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.6."
    },
    "value": "#AF59E1",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.6."
      },
      "value": "Purple600"
    },
    "name": "color.chart.categorical.6.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "6",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.6.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#42B2D7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Teal500"
    },
    "name": "color.chart.categorical.7.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "7",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.7"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.7."
    },
    "value": "#6CC3E0",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.7."
      },
      "value": "Teal400"
    },
    "name": "color.chart.categorical.7.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "7",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.7.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only. Follow numbered sequence."
    },
    "value": "#E06C00",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only. Follow numbered sequence."
      },
      "value": "Orange600"
    },
    "name": "color.chart.categorical.8.[default]",
    "path": [
      "color",
      "chart",
      "categorical",
      "8",
      "[default]"
    ],
    "cleanName": "color.chart.categorical.8"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.categorical.8."
    },
    "value": "#FBD779",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.categorical.8."
      },
      "value": "Orange250"
    },
    "name": "color.chart.categorical.8.hovered",
    "path": [
      "color",
      "chart",
      "categorical",
      "8",
      "hovered"
    ],
    "cleanName": "color.chart.categorical.8.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "For data visualisation only."
    },
    "value": "#82B536",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "For data visualisation only."
      },
      "value": "Lime500"
    },
    "name": "color.chart.lime.bold.[default]",
    "path": [
      "color",
      "chart",
      "lime",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.lime.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "Hovered state of color.chart.lime.bold."
    },
    "value": "#94C748",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "Hovered state of color.chart.lime.bold."
      },
      "value": "Lime400"
    },
    "name": "color.chart.lime.bold.hovered",
    "path": [
      "color",
      "chart",
      "lime",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.lime.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "For data visualisation only."
    },
    "value": "#94C748",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "For data visualisation only."
      },
      "value": "Lime400"
    },
    "name": "color.chart.lime.bolder.[default]",
    "path": [
      "color",
      "chart",
      "lime",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.lime.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "Hovered state of color.chart.lime.bolder."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "Hovered state of color.chart.lime.bolder."
      },
      "value": "Lime300"
    },
    "name": "color.chart.lime.bolder.hovered",
    "path": [
      "color",
      "chart",
      "lime",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.lime.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "For data visualisation only."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "For data visualisation only."
      },
      "value": "Lime300"
    },
    "name": "color.chart.lime.boldest.[default]",
    "path": [
      "color",
      "chart",
      "lime",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.lime.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.8.0",
      "description": "Hovered state of color.chart.lime.boldest."
    },
    "value": "#D3F1A7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.8.0",
        "description": "Hovered state of color.chart.lime.boldest."
      },
      "value": "Lime200"
    },
    "name": "color.chart.lime.boldest.hovered",
    "path": [
      "color",
      "chart",
      "lime",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.lime.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.chart.neutral.[default]",
    "path": [
      "color",
      "chart",
      "neutral",
      "[default]"
    ],
    "cleanName": "color.chart.neutral"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.neutral."
    },
    "value": "#96999E",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.neutral."
      },
      "value": "DarkNeutral700"
    },
    "name": "color.chart.neutral.hovered",
    "path": [
      "color",
      "chart",
      "neutral",
      "hovered"
    ],
    "cleanName": "color.chart.neutral.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#E2483D",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Red600"
    },
    "name": "color.chart.red.bold.[default]",
    "path": [
      "color",
      "chart",
      "red",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.red.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.red.bold."
    },
    "value": "#F15B50",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.red.bold."
      },
      "value": "Red500"
    },
    "name": "color.chart.red.bold.hovered",
    "path": [
      "color",
      "chart",
      "red",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.red.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#F15B50",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Red500"
    },
    "name": "color.chart.red.bolder.[default]",
    "path": [
      "color",
      "chart",
      "red",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.red.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.red.bolder."
    },
    "value": "#F87168",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.red.bolder."
      },
      "value": "Red400"
    },
    "name": "color.chart.red.bolder.hovered",
    "path": [
      "color",
      "chart",
      "red",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.red.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#FD9891",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Red300"
    },
    "name": "color.chart.red.boldest.[default]",
    "path": [
      "color",
      "chart",
      "red",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.red.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.red.boldest."
    },
    "value": "#FFD5D2",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.red.boldest."
      },
      "value": "Red200"
    },
    "name": "color.chart.red.boldest.hovered",
    "path": [
      "color",
      "chart",
      "red",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.red.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#F68909",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Orange500"
    },
    "name": "color.chart.orange.bold.[default]",
    "path": [
      "color",
      "chart",
      "orange",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.orange.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.orange.bold."
    },
    "value": "#FCA700",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.orange.bold."
      },
      "value": "Orange400"
    },
    "name": "color.chart.orange.bold.hovered",
    "path": [
      "color",
      "chart",
      "orange",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.orange.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#FCA700",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Orange400"
    },
    "name": "color.chart.orange.bolder.[default]",
    "path": [
      "color",
      "chart",
      "orange",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.orange.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.orange.bolder."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.orange.bolder."
      },
      "value": "Orange300"
    },
    "name": "color.chart.orange.bolder.hovered",
    "path": [
      "color",
      "chart",
      "orange",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.orange.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#FBD779",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Orange250"
    },
    "name": "color.chart.orange.boldest.[default]",
    "path": [
      "color",
      "chart",
      "orange",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.orange.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.orange.boldest."
    },
    "value": "#FCE4A6",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.orange.boldest."
      },
      "value": "Orange200"
    },
    "name": "color.chart.orange.boldest.hovered",
    "path": [
      "color",
      "chart",
      "orange",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.orange.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#CF9F02",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Yellow500"
    },
    "name": "color.chart.yellow.bold.[default]",
    "path": [
      "color",
      "chart",
      "yellow",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.yellow.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.yellow.bold."
    },
    "value": "#DDB30E",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.yellow.bold."
      },
      "value": "Yellow400"
    },
    "name": "color.chart.yellow.bold.hovered",
    "path": [
      "color",
      "chart",
      "yellow",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.yellow.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#DDB30E",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Yellow400"
    },
    "name": "color.chart.yellow.bolder.[default]",
    "path": [
      "color",
      "chart",
      "yellow",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.yellow.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.yellow.bolder."
    },
    "value": "#EED12B",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.yellow.bolder."
      },
      "value": "Yellow300"
    },
    "name": "color.chart.yellow.bolder.hovered",
    "path": [
      "color",
      "chart",
      "yellow",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.yellow.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#EED12B",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Yellow300"
    },
    "name": "color.chart.yellow.boldest.[default]",
    "path": [
      "color",
      "chart",
      "yellow",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.yellow.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.yellow.boldest."
    },
    "value": "#F5E989",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.yellow.boldest."
      },
      "value": "Yellow200"
    },
    "name": "color.chart.yellow.boldest.hovered",
    "path": [
      "color",
      "chart",
      "yellow",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.yellow.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#2ABB7F",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Green500"
    },
    "name": "color.chart.green.bold.[default]",
    "path": [
      "color",
      "chart",
      "green",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.green.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.green.bold."
    },
    "value": "#4BCE97",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.green.bold."
      },
      "value": "Green400"
    },
    "name": "color.chart.green.bold.hovered",
    "path": [
      "color",
      "chart",
      "green",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.green.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#4BCE97",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Green400"
    },
    "name": "color.chart.green.bolder.[default]",
    "path": [
      "color",
      "chart",
      "green",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.green.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.green.bolder."
    },
    "value": "#7EE2B8",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.green.bolder."
      },
      "value": "Green300"
    },
    "name": "color.chart.green.bolder.hovered",
    "path": [
      "color",
      "chart",
      "green",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.green.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#7EE2B8",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Green300"
    },
    "name": "color.chart.green.boldest.[default]",
    "path": [
      "color",
      "chart",
      "green",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.green.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.green.boldest."
    },
    "value": "#BAF3DB",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.green.boldest."
      },
      "value": "Green200"
    },
    "name": "color.chart.green.boldest.hovered",
    "path": [
      "color",
      "chart",
      "green",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.green.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#42B2D7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Teal500"
    },
    "name": "color.chart.teal.bold.[default]",
    "path": [
      "color",
      "chart",
      "teal",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.teal.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.teal.bold."
    },
    "value": "#6CC3E0",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.teal.bold."
      },
      "value": "Teal400"
    },
    "name": "color.chart.teal.bold.hovered",
    "path": [
      "color",
      "chart",
      "teal",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.teal.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#6CC3E0",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Teal400"
    },
    "name": "color.chart.teal.bolder.[default]",
    "path": [
      "color",
      "chart",
      "teal",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.teal.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.teal.bolder."
    },
    "value": "#9DD9EE",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.teal.bolder."
      },
      "value": "Teal300"
    },
    "name": "color.chart.teal.bolder.hovered",
    "path": [
      "color",
      "chart",
      "teal",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.teal.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#9DD9EE",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Teal300"
    },
    "name": "color.chart.teal.boldest.[default]",
    "path": [
      "color",
      "chart",
      "teal",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.teal.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.teal.boldest."
    },
    "value": "#C6EDFB",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.teal.boldest."
      },
      "value": "Teal200"
    },
    "name": "color.chart.teal.boldest.hovered",
    "path": [
      "color",
      "chart",
      "teal",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.teal.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#357DE8",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Blue600"
    },
    "name": "color.chart.blue.bold.[default]",
    "path": [
      "color",
      "chart",
      "blue",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.blue.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.blue.bold."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.blue.bold."
      },
      "value": "Blue500"
    },
    "name": "color.chart.blue.bold.hovered",
    "path": [
      "color",
      "chart",
      "blue",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.blue.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Blue500"
    },
    "name": "color.chart.blue.bolder.[default]",
    "path": [
      "color",
      "chart",
      "blue",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.blue.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.blue.bolder."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.blue.bolder."
      },
      "value": "Blue400"
    },
    "name": "color.chart.blue.bolder.hovered",
    "path": [
      "color",
      "chart",
      "blue",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.blue.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Blue300"
    },
    "name": "color.chart.blue.boldest.[default]",
    "path": [
      "color",
      "chart",
      "blue",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.blue.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.blue.boldest."
    },
    "value": "#CFE1FD",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.blue.boldest."
      },
      "value": "Blue200"
    },
    "name": "color.chart.blue.boldest.hovered",
    "path": [
      "color",
      "chart",
      "blue",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.blue.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#AF59E1",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Purple600"
    },
    "name": "color.chart.purple.bold.[default]",
    "path": [
      "color",
      "chart",
      "purple",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.purple.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.purple.bold."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.purple.bold."
      },
      "value": "Purple500"
    },
    "name": "color.chart.purple.bold.hovered",
    "path": [
      "color",
      "chart",
      "purple",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.purple.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Purple500"
    },
    "name": "color.chart.purple.bolder.[default]",
    "path": [
      "color",
      "chart",
      "purple",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.purple.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.purple.bolder."
    },
    "value": "#C97CF4",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.purple.bolder."
      },
      "value": "Purple400"
    },
    "name": "color.chart.purple.bolder.hovered",
    "path": [
      "color",
      "chart",
      "purple",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.purple.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Purple300"
    },
    "name": "color.chart.purple.boldest.[default]",
    "path": [
      "color",
      "chart",
      "purple",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.purple.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.purple.boldest."
    },
    "value": "#EED7FC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.purple.boldest."
      },
      "value": "Purple200"
    },
    "name": "color.chart.purple.boldest.hovered",
    "path": [
      "color",
      "chart",
      "purple",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.purple.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#CD519D",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Magenta600"
    },
    "name": "color.chart.magenta.bold.[default]",
    "path": [
      "color",
      "chart",
      "magenta",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.magenta.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.magenta.bold."
    },
    "value": "#DA62AC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.magenta.bold."
      },
      "value": "Magenta500"
    },
    "name": "color.chart.magenta.bold.hovered",
    "path": [
      "color",
      "chart",
      "magenta",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.magenta.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#DA62AC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Magenta500"
    },
    "name": "color.chart.magenta.bolder.[default]",
    "path": [
      "color",
      "chart",
      "magenta",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.magenta.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.magenta.bolder."
    },
    "value": "#E774BB",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.magenta.bolder."
      },
      "value": "Magenta400"
    },
    "name": "color.chart.magenta.bolder.hovered",
    "path": [
      "color",
      "chart",
      "magenta",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.magenta.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#F797D2",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "Magenta300"
    },
    "name": "color.chart.magenta.boldest.[default]",
    "path": [
      "color",
      "chart",
      "magenta",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.magenta.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.magenta.boldest."
    },
    "value": "#FDD0EC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.magenta.boldest."
      },
      "value": "Magenta200"
    },
    "name": "color.chart.magenta.boldest.hovered",
    "path": [
      "color",
      "chart",
      "magenta",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.magenta.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#7E8188",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "DarkNeutral600"
    },
    "name": "color.chart.gray.bold.[default]",
    "path": [
      "color",
      "chart",
      "gray",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.gray.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.gray.bold."
    },
    "value": "#96999E",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.gray.bold."
      },
      "value": "DarkNeutral700"
    },
    "name": "color.chart.gray.bold.hovered",
    "path": [
      "color",
      "chart",
      "gray",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.gray.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#96999E",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "DarkNeutral700"
    },
    "name": "color.chart.gray.bolder.[default]",
    "path": [
      "color",
      "chart",
      "gray",
      "bolder",
      "[default]"
    ],
    "cleanName": "color.chart.gray.bolder"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.gray.bolder."
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.gray.bolder."
      },
      "value": "DarkNeutral800"
    },
    "name": "color.chart.gray.bolder.hovered",
    "path": [
      "color",
      "chart",
      "gray",
      "bolder",
      "hovered"
    ],
    "cleanName": "color.chart.gray.bolder.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation only."
    },
    "value": "#A9ABAF",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation only."
      },
      "value": "DarkNeutral800"
    },
    "name": "color.chart.gray.boldest.[default]",
    "path": [
      "color",
      "chart",
      "gray",
      "boldest",
      "[default]"
    ],
    "cleanName": "color.chart.gray.boldest"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.gray.boldest."
    },
    "value": "#BFC1C4",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.gray.boldest."
      },
      "value": "DarkNeutral900"
    },
    "name": "color.chart.gray.boldest.hovered",
    "path": [
      "color",
      "chart",
      "gray",
      "boldest",
      "hovered"
    ],
    "cleanName": "color.chart.gray.boldest.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Our primary color for data visualisation. Use when only one color is required."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Our primary color for data visualisation. Use when only one color is required."
      },
      "value": "Blue500"
    },
    "name": "color.chart.brand.[default]",
    "path": [
      "color",
      "chart",
      "brand",
      "[default]"
    ],
    "cleanName": "color.chart.brand"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.brand."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.brand."
      },
      "value": "Blue400"
    },
    "name": "color.chart.brand.hovered",
    "path": [
      "color",
      "chart",
      "brand",
      "hovered"
    ],
    "cleanName": "color.chart.brand.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation communicating negative information, such as 'off track'."
    },
    "value": "#E2483D",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation communicating negative information, such as 'off track'."
      },
      "value": "Red600"
    },
    "name": "color.chart.danger.[default].[default]",
    "path": [
      "color",
      "chart",
      "danger",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.chart.danger"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.danger."
    },
    "value": "#F15B50",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.danger."
      },
      "value": "Red500"
    },
    "name": "color.chart.danger.[default].hovered",
    "path": [
      "color",
      "chart",
      "danger",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.chart.danger.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "A stronger emphasis option of color.chart.danger."
    },
    "value": "#FFB8B2",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "A stronger emphasis option of color.chart.danger."
      },
      "value": "Red250"
    },
    "name": "color.chart.danger.bold.[default]",
    "path": [
      "color",
      "chart",
      "danger",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.danger.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.danger.bold."
    },
    "value": "#FD9891",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.danger.bold."
      },
      "value": "Red300"
    },
    "name": "color.chart.danger.bold.hovered",
    "path": [
      "color",
      "chart",
      "danger",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.danger.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation communicating caution, such as 'at risk' statuses."
    },
    "value": "#F68909",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation communicating caution, such as 'at risk' statuses."
      },
      "value": "Orange500"
    },
    "name": "color.chart.warning.[default].[default]",
    "path": [
      "color",
      "chart",
      "warning",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.chart.warning"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.warning."
    },
    "value": "#FCA700",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.warning."
      },
      "value": "Orange400"
    },
    "name": "color.chart.warning.[default].hovered",
    "path": [
      "color",
      "chart",
      "warning",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.chart.warning.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "A stronger emphasis option of color.chart.warning."
    },
    "value": "#FBC828",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "A stronger emphasis option of color.chart.warning."
      },
      "value": "Orange300"
    },
    "name": "color.chart.warning.bold.[default]",
    "path": [
      "color",
      "chart",
      "warning",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.warning.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.warning.bold."
    },
    "value": "#FCE4A6",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.warning.bold."
      },
      "value": "Orange200"
    },
    "name": "color.chart.warning.bold.hovered",
    "path": [
      "color",
      "chart",
      "warning",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.warning.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation communicating positive information, such as 'on track'."
    },
    "value": "#82B536",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation communicating positive information, such as 'on track'."
      },
      "value": "Lime500"
    },
    "name": "color.chart.success.[default].[default]",
    "path": [
      "color",
      "chart",
      "success",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.chart.success"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.success."
    },
    "value": "#94C748",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.success."
      },
      "value": "Lime400"
    },
    "name": "color.chart.success.[default].hovered",
    "path": [
      "color",
      "chart",
      "success",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.chart.success.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "A stronger emphasis option of color.chart.success."
    },
    "value": "#B3DF72",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "A stronger emphasis option of color.chart.success."
      },
      "value": "Lime300"
    },
    "name": "color.chart.success.bold.[default]",
    "path": [
      "color",
      "chart",
      "success",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.success.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.success.bold."
    },
    "value": "#D3F1A7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.success.bold."
      },
      "value": "Lime200"
    },
    "name": "color.chart.success.bold.hovered",
    "path": [
      "color",
      "chart",
      "success",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.success.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation communicating 'new' statuses."
    },
    "value": "#BF63F3",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation communicating 'new' statuses."
      },
      "value": "Purple500"
    },
    "name": "color.chart.discovery.[default].[default]",
    "path": [
      "color",
      "chart",
      "discovery",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.chart.discovery"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.discovery."
    },
    "value": "#C97CF4",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.discovery."
      },
      "value": "Purple400"
    },
    "name": "color.chart.discovery.[default].hovered",
    "path": [
      "color",
      "chart",
      "discovery",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.chart.discovery.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "A stronger emphasis option of color.chart.discovery."
    },
    "value": "#D8A0F7",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "A stronger emphasis option of color.chart.discovery."
      },
      "value": "Purple300"
    },
    "name": "color.chart.discovery.bold.[default]",
    "path": [
      "color",
      "chart",
      "discovery",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.discovery.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.discovery.bold."
    },
    "value": "#EED7FC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.discovery.bold."
      },
      "value": "Purple200"
    },
    "name": "color.chart.discovery.bold.hovered",
    "path": [
      "color",
      "chart",
      "discovery",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.discovery.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "For data visualisation communicating low priority or in-progress statuses."
    },
    "value": "#4688EC",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "For data visualisation communicating low priority or in-progress statuses."
      },
      "value": "Blue500"
    },
    "name": "color.chart.information.[default].[default]",
    "path": [
      "color",
      "chart",
      "information",
      "[default]",
      "[default]"
    ],
    "cleanName": "color.chart.information"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.information."
    },
    "value": "#669DF1",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.information."
      },
      "value": "Blue400"
    },
    "name": "color.chart.information.[default].hovered",
    "path": [
      "color",
      "chart",
      "information",
      "[default]",
      "hovered"
    ],
    "cleanName": "color.chart.information.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "A stronger emphasis option of color.chart.information."
    },
    "value": "#8FB8F6",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "A stronger emphasis option of color.chart.information."
      },
      "value": "Blue300"
    },
    "name": "color.chart.information.bold.[default]",
    "path": [
      "color",
      "chart",
      "information",
      "bold",
      "[default]"
    ],
    "cleanName": "color.chart.information.bold"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.13.3",
      "description": "Hovered state of color.chart.information.bold."
    },
    "value": "#CFE1FD",
    "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.13.3",
        "description": "Hovered state of color.chart.information.bold."
      },
      "value": "Blue200"
    },
    "name": "color.chart.information.bold.hovered",
    "path": [
      "color",
      "chart",
      "information",
      "bold",
      "hovered"
    ],
    "cleanName": "color.chart.information.bold.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use as the primary background for the UI."
    },
    "value": "#1F1F21",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use as the primary background for the UI."
      },
      "value": "DarkNeutral100"
    },
    "name": "elevation.surface.[default].[default]",
    "path": [
      "elevation",
      "surface",
      "[default]",
      "[default]"
    ],
    "cleanName": "elevation.surface"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.20",
      "description": "Hovered state of elevation.surface"
    },
    "value": "#242528",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.20",
        "description": "Hovered state of elevation.surface"
      },
      "value": "DarkNeutral200"
    },
    "name": "elevation.surface.[default].hovered",
    "path": [
      "elevation",
      "surface",
      "[default]",
      "hovered"
    ],
    "cleanName": "elevation.surface.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.20",
      "description": "Pressed state of elevation.surface"
    },
    "value": "#2B2C2F",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.20",
        "description": "Pressed state of elevation.surface"
      },
      "value": "DarkNeutral250"
    },
    "name": "elevation.surface.[default].pressed",
    "path": [
      "elevation",
      "surface",
      "[default]",
      "pressed"
    ],
    "cleanName": "elevation.surface.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
    },
    "value": "#2B2C2F",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
      },
      "value": "DarkNeutral250"
    },
    "name": "elevation.surface.overlay.[default]",
    "path": [
      "elevation",
      "surface",
      "overlay",
      "[default]"
    ],
    "cleanName": "elevation.surface.overlay"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.20",
      "description": "Hovered state of elevation.surface.overlay"
    },
    "value": "#303134",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.20",
        "description": "Hovered state of elevation.surface.overlay"
      },
      "value": "DarkNeutral300"
    },
    "name": "elevation.surface.overlay.hovered",
    "path": [
      "elevation",
      "surface",
      "overlay",
      "hovered"
    ],
    "cleanName": "elevation.surface.overlay.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.20",
      "description": "Pressed state of elevation.surface.overlay"
    },
    "value": "#3D3F43",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.20",
        "description": "Pressed state of elevation.surface.overlay"
      },
      "value": "DarkNeutral350"
    },
    "name": "elevation.surface.overlay.pressed",
    "path": [
      "elevation",
      "surface",
      "overlay",
      "pressed"
    ],
    "cleanName": "elevation.surface.overlay.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
    },
    "value": "#242528",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
      },
      "value": "DarkNeutral200"
    },
    "name": "elevation.surface.raised.[default]",
    "path": [
      "elevation",
      "surface",
      "raised",
      "[default]"
    ],
    "cleanName": "elevation.surface.raised"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.20",
      "description": "Hovered state of elevation.surface.raised"
    },
    "value": "#2B2C2F",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.20",
        "description": "Hovered state of elevation.surface.raised"
      },
      "value": "DarkNeutral250"
    },
    "name": "elevation.surface.raised.hovered",
    "path": [
      "elevation",
      "surface",
      "raised",
      "hovered"
    ],
    "cleanName": "elevation.surface.raised.hovered"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.20",
      "description": "Pressed state of elevation.surface.raised"
    },
    "value": "#303134",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.20",
        "description": "Pressed state of elevation.surface.raised"
      },
      "value": "DarkNeutral300"
    },
    "name": "elevation.surface.raised.pressed",
    "path": [
      "elevation",
      "surface",
      "raised",
      "pressed"
    ],
    "cleanName": "elevation.surface.raised.pressed"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.6.0",
      "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
    },
    "value": "#18191A",
    "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.6.0",
        "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
      },
      "value": "DarkNeutral0"
    },
    "name": "elevation.surface.sunken",
    "path": [
      "elevation",
      "surface",
      "sunken"
    ],
    "cleanName": "elevation.surface.sunken"
  },
  {
    "attributes": {
      "group": "shadow",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use to create a shadow when content scrolls under other content."
    },
    "value": [
      {
        "radius": 12,
        "offset": {
          "x": 0,
          "y": 0
        },
        "color": "#01040475",
        "opacity": 0.56
      },
      {
        "radius": 1,
        "offset": {
          "x": 0,
          "y": 0
        },
        "color": "#01040475",
        "opacity": 0.5
      }
    ],
    "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shadow",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use to create a shadow when content scrolls under other content."
      },
      "value": [
        {
          "radius": 12,
          "offset": {
            "x": 0,
            "y": 0
          },
          "color": "DarkNeutral-100A",
          "opacity": 0.56
        },
        {
          "radius": 1,
          "offset": {
            "x": 0,
            "y": 0
          },
          "color": "DarkNeutral-100A",
          "opacity": 0.5
        }
      ]
    },
    "name": "elevation.shadow.overflow.[default]",
    "path": [
      "elevation",
      "shadow",
      "overflow",
      "[default]"
    ],
    "cleanName": "elevation.shadow.overflow"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.32",
      "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
    },
    "value": "#01040480",
    "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.32",
        "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
      },
      "value": "#01040480"
    },
    "name": "elevation.shadow.overflow.perimeter",
    "path": [
      "elevation",
      "shadow",
      "overflow",
      "perimeter"
    ],
    "cleanName": "elevation.shadow.overflow.perimeter"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "0.10.32",
      "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
    },
    "value": "#0104048f",
    "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "0.10.32",
        "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
      },
      "value": "#0104048f"
    },
    "name": "elevation.shadow.overflow.spread",
    "path": [
      "elevation",
      "shadow",
      "overflow",
      "spread"
    ],
    "cleanName": "elevation.shadow.overflow.spread"
  },
  {
    "attributes": {
      "group": "shadow",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
    },
    "value": [
      {
        "radius": 0,
        "spread": 1,
        "color": "#BDBDBD",
        "offset": {
          "x": 0,
          "y": 0
        },
        "opacity": 0.12
      },
      {
        "radius": 12,
        "offset": {
          "x": 0,
          "y": 8
        },
        "color": "#01040475",
        "opacity": 0.36
      },
      {
        "radius": 1,
        "spread": 1,
        "offset": {
          "x": 0,
          "y": 0
        },
        "color": "#01040475",
        "opacity": 0.5
      }
    ],
    "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shadow",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
      },
      "value": [
        {
          "radius": 0,
          "spread": 1,
          "color": "#BDBDBD",
          "offset": {
            "x": 0,
            "y": 0
          },
          "opacity": 0.12
        },
        {
          "radius": 12,
          "offset": {
            "x": 0,
            "y": 8
          },
          "color": "DarkNeutral-100A",
          "opacity": 0.36
        },
        {
          "radius": 1,
          "spread": 1,
          "offset": {
            "x": 0,
            "y": 0
          },
          "color": "DarkNeutral-100A",
          "opacity": 0.5
        }
      ]
    },
    "name": "elevation.shadow.overlay",
    "path": [
      "elevation",
      "shadow",
      "overlay"
    ],
    "cleanName": "elevation.shadow.overlay"
  },
  {
    "attributes": {
      "group": "shadow",
      "state": "active",
      "introduced": "0.6.0",
      "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
    },
    "value": [
      {
        "radius": 0,
        "spread": 1,
        "color": "#000000",
        "offset": {
          "x": 0,
          "y": 0
        },
        "opacity": 0
      },
      {
        "radius": 1,
        "offset": {
          "x": 0,
          "y": 1
        },
        "color": "#01040475",
        "opacity": 0.5
      },
      {
        "radius": 1,
        "offset": {
          "x": 0,
          "y": 0
        },
        "color": "#01040475",
        "opacity": 0.5
      }
    ],
    "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shadow",
        "state": "active",
        "introduced": "0.6.0",
        "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
      },
      "value": [
        {
          "radius": 0,
          "spread": 1,
          "color": "#000000",
          "offset": {
            "x": 0,
            "y": 0
          },
          "opacity": 0
        },
        {
          "radius": 1,
          "offset": {
            "x": 0,
            "y": 1
          },
          "color": "DarkNeutral-100A",
          "opacity": 0.5
        },
        {
          "radius": 1,
          "offset": {
            "x": 0,
            "y": 0
          },
          "color": "DarkNeutral-100A",
          "opacity": 0.5
        }
      ]
    },
    "name": "elevation.shadow.raised",
    "path": [
      "elevation",
      "shadow",
      "raised"
    ],
    "cleanName": "elevation.shadow.raised"
  },
  {
    "attributes": {
      "group": "opacity",
      "state": "active",
      "introduced": "0.10.13",
      "description": "Apply to images when in a disabled state."
    },
    "value": 0.4,
    "filePath": "schema/themes/atlassian-dark/opacity/opacity.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "opacity",
        "state": "active",
        "introduced": "0.10.13",
        "description": "Apply to images when in a disabled state."
      },
      "value": "Opacity40"
    },
    "name": "opacity.disabled",
    "path": [
      "opacity",
      "disabled"
    ],
    "cleanName": "opacity.disabled"
  },
  {
    "attributes": {
      "group": "opacity",
      "state": "active",
      "introduced": "0.10.13",
      "description": "Apply to content that sits under a loading spinner."
    },
    "value": 0.2,
    "filePath": "schema/themes/atlassian-dark/opacity/opacity.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "opacity",
        "state": "active",
        "introduced": "0.10.13",
        "description": "Apply to content that sits under a loading spinner."
      },
      "value": "Opacity20"
    },
    "name": "opacity.loading",
    "path": [
      "opacity",
      "loading"
    ],
    "cleanName": "opacity.loading"
  },
  {
    "attributes": {
      "group": "raw",
      "state": "active",
      "introduced": "0.1.1",
      "description": "Transparent token used for backwards compatibility between new and old theming solutions"
    },
    "value": "transparent",
    "filePath": "schema/themes/atlassian-dark/utility/utility.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "raw",
        "state": "active",
        "introduced": "0.1.1",
        "description": "Transparent token used for backwards compatibility between new and old theming solutions"
      },
      "value": "transparent"
    },
    "name": "utility.UNSAFE.transparent",
    "path": [
      "utility",
      "UNSAFE",
      "transparent"
    ],
    "cleanName": "utility.UNSAFE.transparent"
  },
  {
    "attributes": {
      "group": "paint",
      "state": "active",
      "introduced": "1.14.0",
      "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
    },
    "value": "#1F1F21",
    "filePath": "schema/themes/atlassian-dark/utility/utility.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "paint",
        "state": "active",
        "introduced": "1.14.0",
        "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
      },
      "value": "DarkNeutral100"
    },
    "name": "utility.elevation.surface.current",
    "path": [
      "utility",
      "elevation",
      "surface",
      "current"
    ],
    "cleanName": "utility.elevation.surface.current"
  }
];

export default tokens;
